// Tooltip — Radix Tooltip wrapper.
// delay·side 옵션. 접근성(aria-describedby)은 Radix 자동.

import {
  Provider,
  Root,
  Trigger,
  Portal,
  Content,
  type TooltipContentProps,
} from '@radix-ui/react-tooltip';
import { type ReactNode } from 'react';

export interface TooltipProps {
  /** 툴팁 내용 */
  content: ReactNode;
  children: ReactNode;
  /** hover 후 표시까지 딜레이 (ms) */
  delayDuration?: number;
  /** 툴팁 방향 */
  side?: TooltipContentProps['side'];
  /** 트리거에서 offset */
  sideOffset?: number;
  /** 비활성 상태 (툴팁 미표시) */
  disabled?: boolean;
}

/**
 * Locker UI — Tooltip
 * @example
 * <Tooltip content="항목 삭제" side="bottom">
 *   <IconButton icon={<Trash />} aria-label="삭제" />
 * </Tooltip>
 */
export function Tooltip({
  content,
  children,
  delayDuration = 400,
  side = 'top',
  sideOffset = 6,
  disabled = false,
}: TooltipProps) {
  if (disabled) return <>{children}</>;

  return (
    <Provider delayDuration={delayDuration}>
      <Root>
        <Trigger asChild>{children}</Trigger>
        <Portal>
          <Content className="ui-tooltip" side={side} sideOffset={sideOffset}>
            {content}
          </Content>
        </Portal>
      </Root>
    </Provider>
  );
}
